module.exports = __webpack_public_path__ + "static/media/21ECLAC38.b676f5f0.jpg";